import React from "react";
import Button from "@material-ui/core/Button";
import {
  clearAccessTokenFromCookies,
  getAccessTokenFromCookies,
} from "../cookies";

const SignInAsUser = (props) => {
  if (
    !props.record.roles.some((role) => role === "ADMIN" || role === "MANAGER")
  ) {
    return null;
  }

  const handleClick = () => {
    const accessToken = getAccessTokenFromCookies();
    const exp = accessToken
      ? // eslint-disable-next-line no-undef
        JSON.parse(atob(accessToken.split(".")[1])).exp
      : undefined;
    if ((exp && Date.now() >= exp * 1000) || !accessToken) {
      clearAccessTokenFromCookies();
      window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/login`;
    }
  };

  return (
    <Button
      target="_blank"
      href={`${process.env.REACT_APP_FRONTEND_URL}?impersonate=${
        props.record.id
      }`}
      color="primary"
      onClick={handleClick}>
      Sign in
    </Button>
  );
};

export default SignInAsUser;



// WEBPACK FOOTER //
// ./src/users/SignInAsUser.js